import { useMutation } from "urql";

import { ChangePasswordDocument } from "../../../graphql/generated.ts";

export function useChangePassword() {
  return useMutation(ChangePasswordDocument);
}
